import React from "react";
import { MOBILE_PREVIEWS } from "./onboarding/onboarding.config";
import "./DemoMobilePreview.css";

/**
 * Driver + parent phone frames. Used in onboarding, the in-demo peek, and
 * the keep-account modal so the mobile apps are visible without sending
 * visitors to a store listing (RouteBot's own listing is not the live one).
 */
const DemoMobilePreview = ({ compact = false, className = "" }) => {
  return (
    <div className={`dmp ${compact ? "dmp--compact" : ""} ${className}`.trim()}>
      {MOBILE_PREVIEWS.map((phone) => (
        <figure key={phone.label} className="dmp-phone">
          <div className="dmp-phone__device">
            <span className="dmp-phone__notch" aria-hidden="true" />
            <div className="dmp-phone__screen">
              <img src={phone.src} alt={phone.label} loading="lazy" />
            </div>
          </div>
          <figcaption>
            <strong>{phone.label}</strong>
            <span>{phone.caption}</span>
          </figcaption>
        </figure>
      ))}
    </div>
  );
};

export default DemoMobilePreview;
